import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useI18n } from "../i18n-context";

export default function NotFoundPage() {
  const { t, lang } = useI18n();
  return (
    <section className="min-h-screen flex items-center justify-center bg-brand-paper pt-32 pb-20">
      <div className="container text-center max-w-2xl">
        <div className="font-display font-extrabold text-9xl md:text-[12rem] text-brand-blue leading-none">
          404
        </div>
        <h1 className="headline text-3xl md:text-4xl text-brand-ink mt-6 mb-4">
          {lang === "ar" ? "الصفحة غير موجودة" : "Page not found"}
        </h1>
        <p className="text-brand-ink/60 mb-10">
          {lang === "ar"
            ? "ربما تم نقل الصفحة أو لم تعد متاحة. عُد إلى الصفحة الرئيسية."
            : "The page may have been moved or no longer exists. Head back home."}
        </p>
        <Link to="/" className="btn-primary">
          <Home className="h-4 w-4" />
          {t.nav.home}
        </Link>
      </div>
    </section>
  );
}
